export function WalletIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 4.11914C2.5 3.29071 3.17157 2.61914 4 2.61914H10.119C10.3294 2.61914 10.5 2.7897 10.5 3.00009V5.61914H4C3.17157 5.61914 2.5 4.94757 2.5 4.11914V4.11914Z"
        stroke="#62887E"
      />
      <path
        d="M2.5 5.61914H11.5C12.6046 5.61914 13.5 6.51457 13.5 7.61914V11.6191C13.5 12.7237 12.6046 13.6191 11.5 13.6191H4.5C3.39543 13.6191 2.5 12.7237 2.5 11.6191V5.61914Z"
        stroke="#62887E"
      />
      <path d="M2.5 4.61914V6.31914" stroke="#62887E" strokeLinecap="square" />
      <circle cx="10.5" cy="9.34766" r="1" fill="#62887E" />
    </svg>
  );
}
